<div class="page-title">
    <div class="row">
        <div class="col-6">
            <!-- <span style="font-weight: 600;" id="LastSyncedTime">
                <img src="assets/images/Icons/clock.png" height="20px" width="20px" alt="">
                <span style="color: #155785;">Last Synced Time</span>
                {{ formattedDate }}

            </span> -->
        </div>
        <div class="col-6">
            <ol class="breadcrumb">
                <div id="animation-holder" style="position: relative;margin-right: 5%;">&nbsp;</div>
                <li class="breadcrumb-item">
                    <a [routerLink]="HomeUrl">
                        <svg class="stroke-icon">
                            <use href="assets/svg/icon-sprite.svg#stroke-home"></use>
                        </svg>
                    </a>
                </li>

                <!-- Parent breadcrumb -->
                @if (breadcrumbs?.parentBreadcrumb) {
                <li class="breadcrumb-item" [class.active]="!breadcrumbs?.childBreadcrumb">
                    {{ breadcrumbs?.parentBreadcrumb }}
                </li>
                }

                <!-- Child breadcrumb (only if exists) -->
                @if (breadcrumbs?.childBreadcrumb) {
                <li class="breadcrumb-item active">
                    {{ breadcrumbs?.childBreadcrumb }}
                </li>
                }
            </ol>
        </div>
    </div>